import Vue from 'vue'
import Vuex from 'vuex'

import certifications from './modules/certifications'
import certRequirements from './modules/certRequirements'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    certifications,
    certRequirements
  },
  state: {
   
  },
  mutations: {
    
  },
  actions: {
  
  }
})
